import React, { useState } from 'react';
import styled from "styled-components";
import TermsAndConditionsModal from './TermsAndConditionsModal';
import { TermsContainer, Link } from '../../../styles';

export class TermsAndConditions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        };
        this.handleEvent = this.handleEvent.bind(this);

      }

    handleEvent(){
        this.setState({
            isModalOpen: !this.state.isModalOpen
        });
    }

    render() {
        return(
            <TermsContainer>
                <Link onClick={this.handleEvent}>{this.props.text}</Link>
                  {this.state.isModalOpen && (
                    <TermsAndConditionsModal handleClick={this.handleEvent} link={this.props.link}/>
                  )}
            </TermsContainer>
        );
    };
}
